<template>
  <transition
    name="modal"
    v-on:after-enter="$emit( 'showed' )"
    v-on:after-leave="$emit( 'hided' )"
  >
    <div class="modal" v-show="show" ref="modal">
      <div class="overlay" @click="$emit('close')" />
      <div class="container" :class=" { fixed, loading, header: title, maximize }">
        <button class="close" @click="$emit('close')">
          <Icon
            :symbol="'close'"
          />
        </button>
				<slot :name="'header'">
					<div v-if="title" class="header">
						<h2 class="title" v-html="title" />
					</div>
				</slot>
        <div
            v-if="hasSlotData"
            class="body"
            :class="scrollContent ? 'scrollContent' : ''"
        >
          <slot />
        </div>
				<slot :name="'controls'">
					<div class="footer">
						<div :class="!acceptButtonText || !cancelButtonText ? 'singular' : ''">
							<button
                class="accept"
								v-if="acceptButtonText"
								@click="$emit('accept')"
							>{{ acceptButtonText }}</button>
							<button
                class="cancel"
								v-if="cancelButtonText"
								@click="$emit('cancel')"
							>{{ cancelButtonText }}</button>
						</div>
					</div>
				</slot>
      </div>
    </div>
  </transition>
</template>

<script>
import Icon from "@/components/Icon";

export default {
	name: "Modal",

	components: {
		Icon
	},

	props:      {
		show: {
			type: Boolean,
			default: false
		},

    fixed: {
		  type: Boolean,
      default: false
    },

    loading: {
		  type: Boolean,
      default: false
    },

    maximize: {
		  type: Boolean,
      default: false
    },

    scrollContent: {
		  type: Boolean,
      default: true
    },

		title: {
			type:    String,
			default: "",
		},

    emptyBodyUse: {
		  type: Boolean,
      default: false
    },

		acceptButtonText: {
			type:	String,
			default: function() { this.$t( "Ok" ) }
		},

		cancelButtonText: {
			type:	String,
			default: function() { this.$t( "Cancel" ) }
		}
	},
  computed: {
  	hasSlotData() {
    	return this.emptyBodyUse || this.$slots.default;
    }
  },
  methods:    {
		onEscapeKey( event ) {
		}
	},
  beforeCreate() {
	  //this makes possible to close only topmost modal window by esc
    if ( !this.$root.$options.__modal__ ) {
      this.$root.$options.__modal__ = {};
      const modal = this.$root.$options.__modal__;
      modal.els = [];
      modal.add = item => {
        if ( !modal.els.length ) window.addEventListener( "keydown", modal.eventHandler, true );
        modal.els.push( item );
      };
      modal.remove = item => {
        let i;
        while ( ( i = modal.els.findIndex( i => i === item ) ) >= 0 ) modal.els.splice( i, 1 );
        if ( !modal.els.length ) window.removeEventListener( "keydown", modal.eventHandler, true );
      };
      modal.eventHandler = e => {
        if ( e.key === "Escape" && modal.els.length ) {
          e.stopImmediatePropagation();
          e.cancelBubble = true;
          e.preventDefault();

          modal.els.pop().$emit( "close" );

          return false;
        }
      };
    }
  },
  beforeDestroy() {
	  this.$root.$options.__modal__.remove( this );
  },
  watch: {
    show: {
      immediate: true,
      handler() {
        this.$root.$options.__modal__.remove( this );
        if ( this.show ) this.$root.$options.__modal__.add( this )
      }
    },

	  loading( v ) {
      if ( !this.$refs.modal ) return;
      const cover = this.$refs.modal

	    if ( v ) {
        if ( !this.loading ) {
          if ( !this.$options.kdh ) {
            this.$options.kdh = e => {
              if ( this.loading ) {
                e.cancelBubble = true;
                e.preventDefault();
                return false;
              }
            }
          }
          cover.addEventListener( "keydown", this.$options.kdh, true );
        }
      }
      else {
        if ( this.loading ) {
          cover.removeEventListener( "keydown", this.$options.kdh, true );
        }
      }
    }
  }
};
</script>

<style scoped>
  .modal {
    position: fixed;
    z-index: var(--zIndex);
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    --zIndex: 10000;
    --bgColor: #FFFFFF;
  }

  .modal > .overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba( 255, 255, 255, .6 ); /*cause it can't use hex form of ---bgColor*/
    z-index: calc( var(--zIndex) + 1 );
  }

  .modal > .container > .close {
    position: absolute;
    right: 1em;
    top: 1em;
    /*transform: translateX( calc( 100% + 25px ) );*/
/*    z-index: calc( var(--zIndex) + 3 );*/
    cursor: pointer;
    border: none;
    background: transparent;
    padding: 0;
    transition: all .25s ease;
    float: right;
  }
  .modal > .container > .close > svg {
    width: 1.5em;
    height: 1.5em;
    fill: #4D4D4D;
  }

  .modal > .container > .close:hover > svg {
    fill: #000000;
  }

  .modal > .container {
/*    transform: scale(1) translate(-50%,-50%); */
    opacity: 1;
    transform: translate(-50%,-50%);
    max-width: 60vw;
    max-height: 80vh;
    position: absolute;
    z-index: calc( var(--zIndex) + 2 );
    background-color: #FFFFFF;
    left: 50%;
    top: 50%;
    margin: 0;
    border-radius: 0.2em;
    box-shadow: 0 4px 34px rgba( 0, 0, 0, 0.25 );
    display: flex;
    flex-direction: column;
    padding: 2em 2em 2.1em 2em;
  }

  .modal > .container.maximize {
    width: 60vw;
    height: 80vh;
  }

  .modal > .container.fixed {
    min-width: 60vw;
    min-height: 80vh;
    justify-content: stretch;
  }
  .modal > .container.fixed > * {
    flex-shrink: 0;
    flex-grow: 0;
  }
  .modal > .container.fixed > .body {
    flex-shrink: 1;
    flex-grow: 1;
  }

  .modal > .container.loading::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: rgba( 255, 255, 255, 0 );
    transition: all 0.2s ease-in-out;
    visibility: hidden;
    background-image: url(data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%202400%202400%22%20width%3D%2232%22%20height%3D%2232%22%3E%3Cg%20stroke-width%3D%22200%22%20stroke-linecap%3D%22round%22%20stroke%3D%22%23000%22%20fill%3D%22none%22%3E%3Cpath%20d%3D%22M1200%20600V100%22%2F%3E%3Cpath%20opacity%3D%22.5%22%20d%3D%22M1200%202300v-500%22%2F%3E%3Cpath%20opacity%3D%22.917%22%20d%3D%22M900%20680.4l-250-433%22%2F%3E%3Cpath%20opacity%3D%22.417%22%20d%3D%22M1750%202152.6l-250-433%22%2F%3E%3Cpath%20opacity%3D%22.833%22%20d%3D%22M680.4%20900l-433-250%22%2F%3E%3Cpath%20opacity%3D%22.333%22%20d%3D%22M2152.6%201750l-433-250%22%2F%3E%3Cpath%20opacity%3D%22.75%22%20d%3D%22M600%201200H100%22%2F%3E%3Cpath%20opacity%3D%22.25%22%20d%3D%22M2300%201200h-500%22%2F%3E%3Cpath%20opacity%3D%22.667%22%20d%3D%22M680.4%201500l-433%20250%22%2F%3E%3Cpath%20opacity%3D%22.167%22%20d%3D%22M2152.6%20650l-433%20250%22%2F%3E%3Cpath%20opacity%3D%22.583%22%20d%3D%22M900%201719.6l-250%20433%22%2F%3E%3Cpath%20opacity%3D%22.083%22%20d%3D%22M1750%20247.4l-250%20433%22%2F%3E%3CanimateTransform%20attributeName%3D%22transform%22%20attributeType%3D%22XML%22%20type%3D%22rotate%22%20keyTimes%3D%220%3B0.08333%3B0.16667%3B0.25%3B0.33333%3B0.41667%3B0.5%3B0.58333%3B0.66667%3B0.75%3B0.83333%3B0.91667%22%20values%3D%220%201199%201199%3B30%201199%201199%3B60%201199%201199%3B90%201199%201199%3B120%201199%201199%3B150%201199%201199%3B180%201199%201199%3B210%201199%201199%3B240%201199%201199%3B270%201199%201199%3B300%201199%201199%3B330%201199%201199%22%20dur%3D%220.83333s%22%20begin%3D%220s%22%20repeatCount%3D%22indefinite%22%20calcMode%3D%22discrete%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E);
    background-repeat: no-repeat;
    background-position: 50% 50%;
    background-size: 3em 3em;
    z-index: calc( var(--zIndex) + 10 );
  }
  .modal > .container.loading {
    pointer-events: none;
  }
  .modal > .container.loading::after {
    visibility: visible;
    background-color: rgba( 255, 255, 255, 0.5 );
  }

  .modal > .container > .header {
    padding: 0;
    margin-right: 2em;
  }

  .modal > .container > .header .title {
    font-size: 1.2em;
    margin: 0;
    color: #808080;
  }

  .modal > .container > .body {
    position: relative;
/*    width: 100%;*/
    margin: 0 -1em 2em 0;
    max-height: 70vh;
    max-width: 70vw;
    background: linear-gradient(white 15px, hsla(0,0%,100%,0)) 0 0 / 100% rem(50px),
              radial-gradient(at top, #F0F0F0, transparent 70%) 0 0 / 100% rem(18px),
              linear-gradient(to top, white 15px, hsla(0,0%,100%,0)) bottom / 100% rem(50px),
              radial-gradient(at bottom, #F0F0F0, transparent 70%) bottom / 100% rem(18px);
    background-repeat: no-repeat;
    background-attachment: local, scroll, local, scroll;
  }
  .modal > .container > .body.scrollContent {
    overflow: auto;
  }
  .modal > .container.header > .body {
    margin-top: 2em;
  }

  .modal > .container > .footer {
    padding: 0;
  }

  .modal > .container > .footer button:hover {
    background-color: #0C97E7;
  }

  .modal > .container > .footer button {
    margin-right: 1em !important;
  }

  .modal > .container > .footer button {
    outline: none;
    border: 1px solid #007BC1;
    background-color: #007BC1;
    color: #FFFFFF;
    fill: #FFFFFF;
    text-transform: uppercase;
    border-radius: 0.2em;
    font-size: inherit;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0.5em 1em;
    -webkit-transition: all .5s ease 0s;
    transition: all .5s ease 0s;
    cursor: pointer;
    font-weight: 500;
  }

  .modal > .container > .footer button.cancel {
    border-width: 2px;
    background-color: #FFFFFF;
    color: #007BC1;
  }
  .modal {
      transition: opacity .35s ease;
  }

  .modal > .overlay {
    transition: opacity .35s ease;
  }

  .modal > .container {
    transition: transform .15s ease;
  }

  .modal-enter,
  .modal-leave-to {
    opacity: 0;
  }

  .modal-enter > .container,
  .modal-leave-to > .container {
/*    transform: scale(1.1) translate(-50%,-50%); */
    transform: translate(-50%,-50%);
    opacity: 0;
  }
</style>
